import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import LeadsList from './pages/LeadsList';
import DoNotCallList from './pages/DoNotCallList';
import LeadForm from './pages/LeadForm';
import BusinessCardUpload from './pages/BusinessCardUpload';
import LeadDetail from './pages/LeadDetail';
import BulkEmail from './pages/BulkEmail';
import SmtpSettings from './pages/SmtpSettings';
import SmsSettings from './pages/SmsSettings';
import ReportsHub from './pages/ReportsHub';
import UserPerformanceReport from './pages/UserPerformanceReport';
import AdAttributionReport from './pages/AdAttributionReport';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import Unsubscribe from './pages/Unsubscribe';
import SuperAdmin from './pages/SuperAdmin';
import CSVImport from './pages/CSVImport';
import PipelineBoard from './pages/PipelineBoard';
import PipelineSettings from './pages/PipelineSettings';
import Inbox from './pages/Inbox';
import Tasks from './pages/Tasks';
import WebhookSettings from './pages/WebhookSettings';
import CustomFields from './pages/CustomFields';
import Duplicates from './pages/Duplicates';
import Automations from './pages/Automations';
import InboundSettings from './pages/InboundSettings';
import VoipSettings from './pages/VoipSettings';
import PhoneAgentSettings from './pages/PhoneAgentSettings';
import OpenDentalSettings from './pages/OpenDentalSettings';
import KnowledgeBase from './pages/KnowledgeBase';
import AIAutoReplySettings from './pages/AIAutoReplySettings';
import TeamMembers from './pages/TeamMembers';
import ClaudeSettings from './pages/ClaudeSettings';
import Privacy from './pages/Legal/Privacy';
import Terms from './pages/Legal/Terms';
import DataDeletion from './pages/Legal/DataDeletion';
import ClaudeIntegration from './pages/Legal/ClaudeIntegration';
import OAuthConsent from './pages/OAuthConsent';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/data-deletion" element={<DataDeletion />} />
      <Route path="/integrations/claude" element={<ClaudeIntegration />} />
      <Route path="/oauth/authorize" element={<OAuthConsent />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route
                  path="/"
                  element={
                    <ProtectedRoute requiredPermission="view_dashboard">
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/leads"
                  element={
                    <ProtectedRoute requiredPermission="view_leads">
                      <LeadsList key="leads" view="leads" />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/do-not-call"
                  element={
                    <ProtectedRoute requiredPermission="view_leads">
                      <DoNotCallList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/customers"
                  element={
                    <ProtectedRoute requiredPermission="view_leads">
                      <LeadsList key="customers" view="customers" />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/leads/new"
                  element={
                    <ProtectedRoute requiredPermission="create_lead">
                      <LeadForm />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/leads/:id"
                  element={
                    <ProtectedRoute requiredPermission="view_leads">
                      <LeadDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/leads/:id/edit"
                  element={
                    <ProtectedRoute requiredPermission="edit_lead">
                      <LeadForm />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/upload"
                  element={
                    <ProtectedRoute requiredPermission="upload_business_card">
                      <BusinessCardUpload />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/bulk-email"
                  element={
                    <ProtectedRoute requiredPermission="send_bulk_email">
                      <BulkEmail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reports"
                  element={
                    <ProtectedRoute requiredPermission="view_reports">
                      <ReportsHub />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reports/users"
                  element={
                    <ProtectedRoute requiredPermission="view_reports">
                      <UserPerformanceReport />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reports/ads"
                  element={
                    <ProtectedRoute requiredPermission="view_reports">
                      <AdAttributionReport />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/smtp-settings"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <SmtpSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/sms-settings"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <SmsSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/inbox"
                  element={
                    <ProtectedRoute requiredPermission="view_leads">
                      <Inbox />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/tasks"
                  element={
                    <ProtectedRoute requiredPermission="view_leads">
                      <Tasks />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/pipeline"
                  element={
                    <ProtectedRoute requiredPermission="view_leads">
                      <PipelineBoard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/pipeline-settings"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <PipelineSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/webhook-settings"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <WebhookSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/custom-fields"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <CustomFields />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/duplicates"
                  element={
                    <ProtectedRoute requiredPermission="edit_lead">
                      <Duplicates />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/automations"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <Automations />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/inbound-settings"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <InboundSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/voip-settings"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <VoipSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/phone-agent-settings"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <PhoneAgentSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/opendental-settings"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <OpenDentalSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/knowledge-base"
                  element={
                    <ProtectedRoute requiredPermission="view_leads">
                      <KnowledgeBase />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/ai-auto-reply"
                  element={
                    <ProtectedRoute requiredPermission="manage_smtp_settings">
                      <AIAutoReplySettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/team"
                  element={
                    <ProtectedRoute requiredPermission="manage_users">
                      <TeamMembers />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/claude-settings"
                  element={
                    <ProtectedRoute>
                      <ClaudeSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/superadmin"
                  element={
                    <ProtectedRoute requiredRole="superadmin">
                      <SuperAdmin />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/import-csv"
                  element={
                    <ProtectedRoute requiredPermission="create_lead">
                      <CSVImport />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App; 